import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome, ${user.full_name}`);
      navigate(location.state?.from || "/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Operator Access</div>
      <h1 className="display-black text-4xl uppercase text-[#064E3B] mt-3 tracking-tighter">Sign in</h1>
      <p className="text-gray-700 mt-2 text-sm">For haulers, affiliates, and administrators.</p>

      <form onSubmit={submit} className="mt-8 space-y-4 border border-gray-300 p-7" data-testid="login-form">
        <input className="input-federal" required type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email" />
        <input className="input-federal" required type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password" />
        <button type="submit" disabled={loading} className="btn-federal w-full justify-center" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <div className="text-sm text-gray-700 mt-4">
        New operator? <Link to="/register" className="text-[#D97706] font-semibold hover:underline" data-testid="link-register">Create an account</Link>
      </div>
    </div>
  );
}
